export const homeCarouselData=[
    {
        image:"https://images.freekaamaal.com/post_images/1567074283.jpg",
        path:"/women/clothing/lengha_choli"
    },
    {
        image:"https://www.latestkurtidesigns.com/wp-content/uploads/2020/04/buy-chanderi-silk-sarees-online.png",
        path:"/women/clothing/women_dress"
    },
    {
        image:"https://www.nihalfashions.com/media/wysiwyg/panel/indian-clothes.jpg",
        path:"/women/clothing/women_dress"
    },
    {
        image:"https://m.media-amazon.com/images/S/aplus-media-library-service-media/1398c6af-dc31-499b-ade0-2fbc83f77a14.__CR0,0,3233,2000_PT0_SX970_V1___.jpg",
        path:"/women/clothing/women_saree"
    }

]

